import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { buildInfo } from './buildInfo';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App buildInfo={buildInfo} />
  </React.StrictMode>
);